import { DeviceSetup, Examination, TaskStep, TestData } from "graphql/types"
import { AddDeviceToSetup } from "./TaskTypes/AddDeviceToSetup"
import { AddHelper } from "./TaskTypes/AddHelper"
import { Engineering } from "./TaskTypes/Engineering"
import { FunctionTest } from "./TaskTypes/FunctionTest"
import { NoteTask } from "./TaskTypes/NoteTask"
import { TestConfiguration } from "./TaskTypes/TestConfiguration"
import { TestFollowUp } from "./TaskTypes/TestFollowUp"
import { WaitingTime } from "./TaskTypes/WaitingTime"

type TaskStepSwitchProps = {
  testData: TestData
  // eslint-disable-next-line no-unused-vars
  setTestData: (data: TestData) => void
  deviceSetup: DeviceSetup[]
  // eslint-disable-next-line no-unused-vars
  setDeviceSetup: React.Dispatch<React.SetStateAction<DeviceSetup[]>>
  examination: Examination | undefined
  // eslint-disable-next-line no-unused-vars
  setExamination: React.Dispatch<React.SetStateAction<Examination | undefined>>
}

export const TaskStepSwitch = (props: TaskStepSwitchProps) => {
  const { testData, setTestData, deviceSetup, setDeviceSetup, examination, setExamination } = props

  switch (testData.type) {
    case TaskStep.ADD_DEVICE:
      return <AddDeviceToSetup deviceSetup={deviceSetup} setDeviceSetup={setDeviceSetup} />
    case TaskStep.NOTE:
      return <NoteTask data={testData} setData={setTestData} />
    case TaskStep.FUNCTION_TEST:
      return (
        <FunctionTest
          data={testData}
          setData={setTestData}
          deviceSetup={deviceSetup}
          examination={examination}
        />
      )
    case TaskStep.TEST_CONFIGURATION:
      return (
        <TestConfiguration
          data={testData}
          setData={setTestData}
          examination={examination}
          setExamination={setExamination}
        />
      )
    case TaskStep.TEST_FOLLOW_UP:
      return (
        <TestFollowUp
          data={testData}
          setData={setTestData}
          deviceSetup={deviceSetup}
          examination={examination}
        />
      )

    case TaskStep.ENGINEERING:
      return <Engineering data={testData} setData={setTestData} />

    case TaskStep.WAITING_TIME:
      return <WaitingTime data={testData} setData={setTestData} />
    case TaskStep.HELPER:
      return <AddHelper data={testData} setData={setTestData} />
    default:
      return null
  }
}
